import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, getLang, secureToken } from '../utils/utils';
import { getApi } from './getApi';
import { getApiFile } from './getApiFile';

export const apiGetAbstract = async (
  route: string,
  name: string,
  download?: number
) => {
  const params: IApiParams = {
    url: `/getAbstract.php?baseName=${route}&name=${name}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
      'Api-Lang': getLang(),
    },
  };
  if (download !== undefined && download === 1) {
    return getApiFile(params, 'GET');
  }
  return getApi(params, 'GET');
};
